import type { ThemeOptions } from '@mui/material';

import { black } from '~/styles/colors';

const DialogTheme: ThemeOptions['components'] = {
  MuiDialog: {
    styleOverrides: {
      paper: ({ theme }) => ({
        borderRadius: '0.375rem',
        boxShadow: `0px 5px 24px ${black[300]}`,
        margin: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
          width: 'calc(100% - 32px)',
        },
        [theme.breakpoints.up('md')]: {
          width: '460px',
        },
        '&.MuiDialog-paperFullWidth': { width: '100%' },
      }),
    },
  },
};

export default DialogTheme;
